import { Drawer, IconButton, Typography } from "@material-ui/core"
import BottomNavigation from "@material-ui/core/BottomNavigation"
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction"
import { createMuiTheme, makeStyles, ThemeProvider } from "@material-ui/core/styles"
import { Close, Translate } from "@material-ui/icons"
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat"
import LoyaltyIcon from "@material-ui/icons/Loyalty"
import PersonIcon from "@material-ui/icons/Person"
import RoomServiceIcon from "@material-ui/icons/RoomService"
import StoreIcon from "@material-ui/icons/Store"
import React, { useContext, useState } from "react"
import { LoginDialogContext } from "../../components/LoginDialog"
import useParametros from "../../contexts/ParametrosContext"
import SiteContext from "../../contexts/SiteContext"
import { TextosContext, useTextos } from "../../contexts/TextosContext"
import useCustomHistory from "../../hooks/useCustomHistory"
import { identificarEstabelecimentoSelecionado } from "../../services/functions"
import "./styles.css"

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
    },
    svg: {
        color: "#fff",
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    drawerIdiomas: {
        // position: "relative",
        borderRadius: "1rem 1rem 0 0",
        padding: "0.5rem 0",
        "& .drawer-idiomas-container": {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "0.5rem",
            padding: "0.5rem",
            borderRadius: "1rem 2rem 3rem 4rem",
        },
        "& .drawer-idiomas-seletor": {
            display: "flex",
            flexDirection: "column",
            border: "1px solid #0009",
            padding: "0.25rem",
            borderRadius: "0.5rem",
            transition: "background-color 0.5s",
            "&[data-selecionado='true']": {
                borderColor: "black",
                // borderWidth: "2px",
                backgroundColor: "#0002",
            },
        },
        "& .drawer-idiomas-close": {
            position: "absolute",
            border: "1px solid #0002",
            top: "0.5rem",
            right: "0.5rem",
            padding: "0.25rem",
        },
    },
}))

function IdiomasButton() {
    const { textos, idioma, setIdioma, idiomas } = useContext(TextosContext)
    const classes = useStyles()

    const [isOpenIdiomasDrawer, setIsOpenIdiomasDrawer] = useState(false)
    const handleOpen = () => setIsOpenIdiomasDrawer(true)
    const handleClose = () => setIsOpenIdiomasDrawer(false)

    return (
        <>
            <BottomNavigationAction
                color="primary"
                variant="outlined"
                label="idiomas"
                onClick={handleOpen}
                icon={<Translate />}
                className={classes.svg}
            >
                {textos.siglaSimplificada}
            </BottomNavigationAction>
            <Drawer
                open={isOpenIdiomasDrawer}
                onClose={handleClose}
                anchor="bottom"
                PaperProps={{ className: classes.drawerIdiomas }}
            >
                <Typography align="center" variant="h6" componente="span">
                    {textos.escolhaIdioma}
                </Typography>
                <div className="drawer-idiomas-container">
                    {Object.entries(idiomas).map(([seletor, { nomeIdioma, detalhesIdioma }]) => (
                        <div
                            className="drawer-idiomas-seletor"
                            data-selecionado={idioma === seletor}
                            onClick={() => setIdioma(seletor)}
                        >
                            <Typography variant="subtitle2">{nomeIdioma}</Typography>
                            <Typography variant="caption">{detalhesIdioma}</Typography>
                        </div>
                    ))}
                </div>
                <IconButton onClick={handleClose} className="drawer-idiomas-close">
                    <Close />
                </IconButton>
            </Drawer>
        </>
    )
}

export default function Rodape(props) {
    const {
        aplicativoDados,
        setAplicativoDados,

        estabelecimentoAtual,
        setEstabelecimentoAtual,

        usuarioLogado,
        setUsuarioLogado,

        carrinho,
        setCarrinho,
    } = useContext(SiteContext)

    const { setAbrirDialogLogin } = useContext(LoginDialogContext)

    const textos = useTextos()
    const parametros = useParametros()

    const classes = useStyles()
    const [value, setValue] = React.useState(props.valor)
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const history = useCustomHistory()

    const theme = createMuiTheme({
        palette: {
            primary: {
                light: `${
                    !aplicativoDados?.corSiteSecundaria ||
                    aplicativoDados?.corSiteSecundaria === aplicativoDados?.corSitePrimaria
                        ? "#6c757d"
                        : aplicativoDados?.corSiteSecundaria
                }`,
                main: `${
                    !aplicativoDados?.corSiteSecundaria ||
                    aplicativoDados?.corSiteSecundaria === aplicativoDados?.corSitePrimaria
                        ? "#6c757d"
                        : aplicativoDados?.corSiteSecundaria
                }`,
                // dark: will be calculated from palette.secondary.main,
                contrastText: `#000000`,
            },
            secondary: {
                light: `${
                    !aplicativoDados?.corSiteSecundaria
                        ? "#6c757d"
                        : aplicativoDados?.corSiteSecundaria
                }`,
                main: `${
                    !aplicativoDados?.corSitePrimaria ? "#6c757d" : aplicativoDados?.corSitePrimaria
                }`,
                contrastText: `#fff`,
            },
        },
    })

    const usuarioPedidoMesa = JSON.parse(localStorage.getItem("usuarioPedidoMesaCF"))

    const textoCardapio = parametros?.PUBLIC_TEXTO_CARDAPIO_RODAPE ?? textos.cardapio
    const IconeCardapio =
        parametros?.PUBLIC_TEXTO_CARDAPIO_RODAPE === "Passeios"
            ? DirectionsBoatIcon
            : RoomServiceIcon

    //PEDIDO MESA
    if (usuarioPedidoMesa?.logado) {
        return (
            <div className="RodapeComponente" id="RodapeComponente">
                <ThemeProvider theme={theme}>
                    <BottomNavigation
                        value={value}
                        onChange={handleChange}
                        className={classes.root}
                        style={{ backgroundColor: `${aplicativoDados?.corSitePrimaria}` }}
                    >
                        <BottomNavigationAction
                            onClick={() => {
                                if (estabelecimentoAtual?.id && value !== "Delivery") {
                                    const [url, params] =
                                        identificarEstabelecimentoSelecionado(aplicativoDados)
                                    history.push(`/delivery` + url, params)
                                }
                            }}
                            label={textoCardapio}
                            className={classes.svg}
                            value="Delivery"
                            icon={<IconeCardapio />}
                        />

                        {aplicativoDados?.estabelecimentos?.length > 1 && (
                            <BottomNavigationAction
                                onClick={() => {
                                    if (estabelecimentoAtual?.id && value !== "Estabelecimento") {
                                        history.push(`/lojas`)
                                    }
                                }}
                                label="Lojas"
                                className={classes.svg}
                                value="Estabelecimento"
                                icon={<StoreIcon />}
                            />
                        )}

                        <IdiomasButton />
                    </BottomNavigation>
                </ThemeProvider>
            </div>
        )
    } else if (usuarioLogado?.logado) {
        return (
            <div className="RodapeComponente" id="RodapeComponente">
                <ThemeProvider theme={theme}>
                    <BottomNavigation
                        value={value}
                        onChange={handleChange}
                        className={classes.root}
                        style={{ backgroundColor: `${aplicativoDados?.corSitePrimaria}` }}
                    >
                        <BottomNavigationAction
                            onClick={() => {
                                if (value !== "Delivery") {
                                    if (estabelecimentoAtual?.id) {
                                        const [url, params] =
                                            identificarEstabelecimentoSelecionado(aplicativoDados)
                                        history.push(`/delivery` + url, params)
                                    } else {
                                        history.push(`/estabelecimento`)
                                    }
                                }
                            }}
                            label={textoCardapio}
                            className={classes.svg}
                            value="Delivery"
                            icon={<IconeCardapio />}
                        />

                        {aplicativoDados?.apenasDelivery === false && (
                            <BottomNavigationAction
                                onClick={() => {
                                    if (value !== "Fidelidade") history.push(`/delivery/fidelidade`)
                                }}
                                label="Fidelidade"
                                className={classes.svg}
                                value="Fidelidade"
                                icon={<LoyaltyIcon />}
                            />
                        )}

                        {usuarioLogado.estabelecimentos.length > 1 ? (
                            <BottomNavigationAction
                                onClick={() => {
                                    if (value !== "Estabelecimento")
                                        history.push(`/estabelecimento`)
                                }}
                                label="Lojas"
                                className={classes.svg}
                                value="Estabelecimento"
                                icon={<StoreIcon />}
                            />
                        ) : null}

                        <IdiomasButton />
                        <BottomNavigationAction
                            onClick={() => {
                                if (value !== "Perfil") history.push(`/perfil`)
                            }}
                            label="Perfil"
                            className={classes.svg}
                            value="Perfil"
                            icon={<PersonIcon />}
                        />
                    </BottomNavigation>
                </ThemeProvider>
            </div>
        )
    } else {
        return (
            <div className="RodapeComponente" id="RodapeComponente">
                <ThemeProvider theme={theme}>
                    <BottomNavigation
                        value={value}
                        onChange={handleChange}
                        className={classes.root}
                        style={{ backgroundColor: `${aplicativoDados?.corSitePrimaria}` }}
                    >
                        <BottomNavigationAction
                            onClick={() => {
                                if (estabelecimentoAtual?.id && value !== "Delivery") {
                                    const [url, params] =
                                        identificarEstabelecimentoSelecionado(aplicativoDados)
                                    history.push(`/delivery` + url, params)
                                }
                            }}
                            label={textoCardapio}
                            className={classes.svg}
                            value="Delivery"
                            icon={<IconeCardapio />}
                        />

                        {aplicativoDados?.estabelecimentos?.length > 1 && (
                            <BottomNavigationAction
                                onClick={() => {
                                    if (estabelecimentoAtual?.id && value !== "Estabelecimento") {
                                        history.push(`/lojas`)
                                    }
                                }}
                                label="Lojas"
                                className={classes.svg}
                                value="Estabelecimento"
                                icon={<StoreIcon />}
                            />
                        )}

                        <IdiomasButton />
                        <BottomNavigationAction
                            onClick={() => {
                                if (!usuarioLogado?.logado) {
                                    setAbrirDialogLogin(true)
                                }
                            }}
                            label="Login"
                            className={classes.svg}
                            value="Login"
                            icon={<PersonIcon />}
                        />
                    </BottomNavigation>
                </ThemeProvider>
            </div>
        )
    }
}
